import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgAu = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#0052B4",
      d: "M24 12c0 6.628-5.373 12-12 12S0 18.628 0 12L12 .005h.341C18.811.185 24 5.487 24 12"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "m7.894 15.46-.657-1.379-.656 1.379-1.486-.343.666 1.374-1.195.947 1.48.337V19.3l1.191-.952 1.191.952-.005-1.524 1.491-.337-1.195-.947.665-1.374zm10.401 1.921-.328-.689-.328.69-.745-.174.333.684-.6.479.745.164v.764l.595-.479.59.479v-.764l.746-.165-.595-.478.333-.684zm-3.065-7.303-.328-.689-.329.69-.74-.17.328.69-.595.468.74.17V12l.596-.478.595.478-.005-.764.75-.173-.6-.47.338-.683zm3.065-4.172-.328-.689-.333.69-.745-.174.333.69-.6.473.745.168v.764l.595-.478.591.478v-.764l.745-.173-.595-.469.338-.689zm2.672 3.132-.328-.69-.328.69-.74-.174.332.69-.6.473.745.168v.755l.596-.469.59.474v-.76l.746-.173-.596-.469.333-.689zm-1.973 3.759L18.73 12l-.258.792h-.843l.68.493-.258.796.675-.492.68.492-.259-.796.68-.488zM11.661.005H12V1.57l-.553 1.565L12 4.702v1.565H8.475L12 9.792v.736l-.36.478.36.999H9.787L6.262 8.48v3.525H4.697l-1.538-.638-1.593.638H0V12C0 5.486 5.19.184 11.661.005"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M7.735 6.263 12 10.528v1.477L6.263 6.263z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M1.565 6.07v5.935h3.132V4.702H12V1.57H6.06a12.06 12.06 0 0 0-4.495 4.5"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgAu;